import type { BusinessData } from 'types/business'

/**
 * Determines whether the DISCO logo should be visible based on business metadata.
 *
 * Checks business metadata settings with the following priority:
 * 1. Explicit show_disco_logo setting if defined
 * 2. Inverse of whitelabel setting if defined
 * 3. Defaults to true if neither setting exists
 *
 * @param businessMetadata - The business configuration data
 * @returns Whether the DISCO logo should be displayed
 */
export const getLogoVisibility = (businessMetadata: BusinessData): boolean => {
  if (businessMetadata.public_metadata.show_disco_logo !== undefined) {
    return businessMetadata.public_metadata.show_disco_logo
  } else if (businessMetadata.public_metadata.whitelabel !== undefined) {
    return !businessMetadata.public_metadata.whitelabel
  }
  return true
}

/**
 * Determines whether the "Save to DISCO" option should be visible based on business metadata.
 *
 * Checks business metadata settings with the following priority:
 * 1. Explicit show_save_to_disco setting if defined
 * 2. Inverse of whitelabel setting if defined
 * 3. Defaults to true if neither setting exists
 *
 * @param businessMetadata - The business configuration data
 * @returns Whether the "Save to DISCO" option should be displayed
 */
export const getSaveToDiscoVisibility = (
  businessMetadata: BusinessData,
): boolean => {
  if (businessMetadata.public_metadata.show_save_to_disco !== undefined) {
    return businessMetadata.public_metadata.show_save_to_disco
  } else if (businessMetadata.public_metadata.whitelabel !== undefined) {
    return !businessMetadata.public_metadata.whitelabel
  }
  return true
}
